module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-11.563b07aa.png";